import { FileText } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const LogsIcon = DeckardIconWrapper({ Icon: FileText });
